import { render, staticRenderFns } from "./TagListPage.vue?vue&type=template&id=770aece2&scoped=true&"
import script from "./TagListPage.vue?vue&type=script&lang=js&"
export * from "./TagListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770aece2",
  null
  
)

export default component.exports